import React from "react";

import css from "./styles.styl";

const SHADED_CLASSES = {
	light: css.light,
	medium: css.medium,
	dark: css.dark,
};

export const Hotkey = ({ children, shade = "light", className }) => {
	const shadeClass = SHADED_CLASSES[shade];

	return <span className={`${css.hotkey} ${shadeClass} ${className}`}>{children}</span>;
};
